<template>
    <a class="nav-link" :href="urlWishList" rel="nofollow">
        <span class="badge-right">{{ wishListCount }}</span>
        <img :src="pluginPathTheme + '/images/wishlist.svg'" alt="wishlist">
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount() {
            return this.$store.getters.wishListCount;
        },

        urlWishList() {
            return App.urls.wishList;
        },
        pluginPathTheme() {
            return App.pluginPathTheme
        },
    }
}
</script>
